var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calculator"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49,62H15a7.008,7.008,0,0,1-7-7V9a7.008,7.008,0,0,1,7-7H49a7.008,7.008,0,0,1,7,7V55A7.008,7.008,0,0,1,49,62ZM15,4a5.006,5.006,0,0,0-5,5V55a5.006,5.006,0,0,0,5,5H49a5.006,5.006,0,0,0,5-5V9a5.006,5.006,0,0,0-5-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,58H29a3,3,0,0,1-3-3V51a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,35,58Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V51a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,58H15a3,3,0,0,1-3-3V51a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,21,58Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V51a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,58H43a3,3,0,0,1-3-3V39a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3V55A3,3,0,0,1,49,58ZM43,38a1,1,0,0,0-1,1V55a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V39a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,46H29a3,3,0,0,1-3-3V39a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,35,46Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V39a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,46H15a3,3,0,0,1-3-3V39a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,21,46Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V39a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,34H29a3,3,0,0,1-3-3V27a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,35,34Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V27a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,34H15a3,3,0,0,1-3-3V27a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,21,34Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V27a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,34H43a3,3,0,0,1-3-3V27a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4A3,3,0,0,1,49,34Zm-6-8a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V27a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,20H15a3,3,0,0,1-3-3V9a3,3,0,0,1,3-3H49a3,3,0,0,1,3,3v8A3,3,0,0,1,49,20ZM15,8a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1H49a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,17a3,3,0,0,1-3-3V12a3,3,0,0,1,6,0v2A3,3,0,0,1,46,17Zm0-6a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V12A1,1,0,0,0,46,11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.4aabfab7acfdd4c0d55cca2d63dae6ad.svg";
export { ForwardRef as ReactComponent };